import L from 'leaflet'

/**
 * Check if a tile at given coordinates intersects with data bounds
 * Used to avoid requesting tiles outside the actual data coverage area
 */
export function tileIntersectsDataBounds(
  z: number,
  x: number,
  y: number,
  dataBounds: L.LatLngBounds
): boolean {
  // Convert tile coordinates to lat/lng bounds
  const n = Math.PI - (2 * Math.PI * y) / Math.pow(2, z)
  const lat1 = (180 / Math.PI) * Math.atan(0.5 * (Math.exp(n) - Math.exp(-n)))
  const lat2 = (180 / Math.PI) * Math.atan(0.5 * (Math.exp(Math.PI - (2 * Math.PI * (y + 1)) / Math.pow(2, z)) - Math.exp(-(Math.PI - (2 * Math.PI * (y + 1)) / Math.pow(2, z)))))
  const lng1 = (x / Math.pow(2, z)) * 360 - 180
  const lng2 = ((x + 1) / Math.pow(2, z)) * 360 - 180

  const tileBounds = L.latLngBounds(
    L.latLng(Math.min(lat1, lat2), Math.min(lng1, lng2)),
    L.latLng(Math.max(lat1, lat2), Math.max(lng1, lng2))
  )

  return dataBounds.intersects(tileBounds)
}

/**
 * Get color for vulnerability level
 */
export function getVulnerabilityColor(vulnerability: 'low' | 'medium' | 'high' | 'critical') {
  return {
    'low': '#22c55e',
    'medium': '#eab308',
    'high': '#f97316',
    'critical': '#ef4444'
  }[vulnerability] || '#6b7280'
}

/**
 * Get emoji for property type
 */
export function getTypeEmoji(type: 'residential' | 'commercial' | 'industrial') {
  return {
    'residential': '🏠',
    'commercial': '🏢',
    'industrial': '🏭'
  }[type] || '📍'
}
